import { HomeMenuThemeSizeConfig } from './types';

const medium: HomeMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default medium;
